(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/lobby/games.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/lobby/games.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const validateGameConfig = gameConfig => {
  const {
    playUrl,
    demoUrl,
    infoUrl,
    minPrice,
    name,
    maxWin,
    url,
    leiaType,
    infoImage,
    image
  } = gameConfig;
  const requiredObj = {
    playUrl,
    demoUrl,
    infoUrl,
    minPrice,
    name,
    maxWin,
    leiaType,
    url,
    infoImage,
    image
  }; 
  const validationError = Object.values(requiredObj).filter(val => !val);
  if (validationError.length > 0) {
    const missingKeyVal = [];
    Object.keys(requiredObj).forEach(key => {
      if (!requiredObj[key]) {
        missingKeyVal.push(key);
      }
    });
    svs.eInstant.logger.warn("failed to display \"".concat(name || url || undefined, "\" with missing keys: ").concat(missingKeyVal.join(', ')));
    return false;
  }

  if (gameConfig.status && gameConfig.status !== 'OPEN') {
    return false;
  }
  return true;
};
const Games = () => {
  const {
    LOBBY
  } = svs.eInstant.constants.ROUTES;
  const {
    Grid,
    GridRow,
    GridCol
  } = svs.ui.ReactGrid;
  const {
    useContext,
    useMemo,
    useEffect
  } = React;
  const {
    state,
    gameConfigs,
    lobbyHeader
  } = useContext(svs.eInstant.lobby.LobbyContext);
  const Game = svs.eInstant.lobby.Game;
  const games = useMemo(() => gameConfigs === null || gameConfigs === void 0 ? void 0 : gameConfigs.filter(validateGameConfig), [gameConfigs]);
  const {
    update
  } = svs.eInstant.shared.hooks.useMetaTags();
  useEffect(() => {
    if (!state.gameUrl) {
      update(LOBBY);
      svs.eInstant.util.showFooter();
    }
  }, [state.gameUrl]);
  useEffect(() => {
    update(LOBBY);
    svs.eInstant.util.showFooter();
  }, []);
  return React.createElement(Grid, null, React.createElement("div", {
    className: "e-instant-lobby-games-container"
  }, lobbyHeader && React.createElement("div", {
    className: "e-instant-font-wrapper"
  }, React.createElement("h2", {
    className: "fc-white f-center e-instant-lobby-header margin-bottom-3"
  }, lobbyHeader)), React.createElement(GridRow, {
    "data-testid": "e-instant-games-list",
    md: {
      gutter: 12
    },
    sm: {
      gutter: 12
    },
    xs: {
      gutter: 12
    }
  },
  games.map((game, i) => React.createElement(GridCol, {
    key: game.url,
    md: 3,
    sm: 4,
    xs: 6
  }, React.createElement(Game, _objectSpread(_objectSpread({}, game), {}, {
    listIndex: i
  })))))));
};
setGlobal('svs.eInstant.lobby.Games', Games);

 })(window);